var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content",class:("page-" + (_vm.$route.name))},[_c('left-navigation'),_c('div',{staticClass:"content"},[_c('breadcrumbs'),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }